import { AnyAction } from 'redux';
import {
  App,
  getVetragsOptionenFromVorvertrag,
  RsVorbelegungdaten,
  Vertragsoptionen,
} from '@ps20-frontend/frontend-models';
import { addVorvertragToAngeboteReducer, vertragsoptionenReducer } from '@ps20-frontend/reducers';
import { Selbstbeteiligung } from '@ps20/bff-models';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { IAppState } from '../appState';
import { RsVermieterActions } from '../rs-vermietung-actions.service';

export interface VertragsoptionenVermieterRS extends Vertragsoptionen {
  urbeginn?: string;
}
export const rsVermietungVertragsoptionenReducer = function (
  sectionState: VertragsoptionenVermieterRS = null,
  action: AnyAction,
  state: IAppState,
): VertragsoptionenVermieterRS {
  sectionState = vertragsoptionenReducer(sectionState, action, App.RS_VERMIETUNG, state);
  switch (action.type) {
    case RsVermieterActions.SELBSTBETEILIGUNG_CHANGED: {
      const selbstbeteiligung: Selbstbeteiligung = action.payload;
      return { ...sectionState, selbstbeteiligung };
    }
    case GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE: {
      return addVorvertragToAngeboteReducer(sectionState, action, App.RS_VERMIETUNG);
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: RsVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.RS_VERMIETUNG) {
        const newState: Vertragsoptionen = getVetragsOptionenFromVorvertrag(
          sectionState,
          actionPayload,
        );
        return { ...newState };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
